import { Skeleton } from "@scaleaq/sui-react";
import styles from "./LoadingGhost.skeleton.module.scss";
import clsx from "clsx";

export namespace LoadingGhostSkeleton {
    export type ElementName = "LoadingGhost.Ghost";
    export type ElementType = HTMLElement;
    export type Props = Skeleton.Props;
}

export const LoadingGhostSkeleton = (props: LoadingGhostSkeleton.Props) => {
    const { className, ...restProps } = props;

    return(<Skeleton className={clsx(styles["skeleton"], className)} {...restProps} />);
}